import React from "react";
import "./client-section.scss";

const clients = [
  {
    name: "CPB Contractors",
    logo: "/images/clients/cpb.png",
  },
  {
    name: "Downer",
    logo: "/images/clients/downer.webp",
  },
  {
    name: "Acciona",
    logo: "/images/clients/acciona.png",
  },
  {
    name: "Fulton Hogan",
    logo: "/images/clients/fulton-hogan.png",
  },
  {
    name: "John Holland",
    logo: "/images/clients/john-holland.png",
  },
  {
    name: "Kane Constructions",
    logo: "/images/clients/kane-constructions.png",
  },
];

const ClientSection = () => {
  const sliderClients = [...clients, ...clients];

  return (
    <section className="client-section">
      <div className="client-section-inner">
        <div className="client-content">
          <h2>
            Trusted by <span>Leading Companies</span>
          </h2>

          <p>
            Proudly supporting Australia&apos;s leading contractors, councils and
            infrastructure projects.
          </p>
        </div>

        <div className="client-slider">
          <div className="client-slider-track">
            {sliderClients.map((client, index) => (
              <div className="client-logo-item" key={index}>
                <img src={client.logo} alt={client.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientSection;